import React from "react";
import { BiLoaderCircle } from "react-icons/bi";
import { Link } from "react-router-dom";
import Logo from "../../assets/Logo_Bakeli.png"
import { footerItems } from "../Utils/UtilsTask";
import Newsletter from "./Newsletter";

export const FooterPageAcueil = () => {
  const date = new Date();
  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
    };
    return new Date(dateString).toLocaleDateString("fr-FR", options);
  };

  return (
    <div className=" mt-20 py-8 text-sm tracking-wide bg-fondfooter bg-no-repeat bg-cover relative">
      <div className="flex items-center justify-center md:max-w-full pt-10 max-sm:pt-4">
        <Newsletter />
        <div className="flex flex-wrap items-start justify-between text-sm sm:justify-between md:justify-between w-[88%] max-lg:mt-10">
          <div className="flex flex-col gap-3 max-sm:w-full w-[38%]">
            <a className={`flex items-center gap-2`} href="/">
              <BiLoaderCircle className={`text-[26px] text-orange`} />
              <span
                className={`text-[17px] font-[500] text-vrt font-inter self-center whitespace-nowrap`}
              >
                Bakeli Work
              </span>
            </a>
            <div className="flex flex-col gap-2 text-sm font-inter ">
              <p className="inline-flex font-mandali text-noirel text-sm ">
                Bakeli Work est un service mis en place par Bakeli pour
                accompagner les entrepreneurs dans l'accès à des services
                digitaux (conception de logos, affiches, sites web et
                applications) à des prix très compétitifs et avec une grande
                flexibilité. Seuls les Bakelistes sont habilités à postuler pour
                réaliser ces prestations.
              </p>
              {/* <p className="inline-flex font-mandali text-sm ">
                +01 ( 1234 567 890 )
              </p> */}
            </div>
          </div>
          <div className={`flex justify-between w-[60%]`}>
            {footerItems.map((item, i) => (
              <div
                className={`flex flex-col max-sm:mt-6 gap-3 text-noirel`}
                key={i}
              >
                <h3
                  className={`text-lg font-semibold inline-flex gap-1 items-center font-inter `}
                >
                  {item.title?.text}
                </h3>
                <div className="flex flex-col font-mandali  text-sm gap-3 pt-2">
                  <Link
                    to={item.linkOne?.path ? item.linkOne?.path : ""}
                    className="inline-flex gap-2 items-center"
                  >
                    {item.linkOne?.text}
                  </Link>
                  <Link
                    to={item.linkTwo?.path ? item.linkTwo?.path : ""}
                    className="inline-flex gap-2 items-center"
                  >
                    {item.linkTwo?.text}
                  </Link>
                  <Link
                    to={item.linkThree?.path ? item.linkThree?.path : ""}
                    className="inline-flex gap-2 items-center"
                  >
                    {item.linkThree?.text}
                  </Link>
                  <Link
                    to={item.linkFour ? item.linkFour?.path : ""}
                    className="inline-flex gap-2 items-center"
                  >
                    {item.linkFour?.text}
                  </Link>
                  <Link
                    to={item.linkFive ? item.linkFive?.path : ""}
                    className="inline-flex gap-2 items-center"
                  >
                    {item.linkFive?.text}
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <div className="w-full mt-10">
            <p className="text-center">
              © Copyright{" "}
              <span>
                <a
                  href="https://www.bakeli.tech/"
                  target="_blank"
                  className="text-vr font-bold"
                >
                  Bakeli 2025.
                </a>
              </span>{" "}
              Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
